import { createRouter, createWebHistory } from 'vue-router'
import FinishedGoodsAnalysis from '@/components/FinishedGoodsAnalysis.vue'
import ComponentAnalysis from '@/components/ComponentAnalysis.vue'
import OARegistrar from '@/components/OARegistrar.vue';
import DeliverySchedule from '@/components/DeliverySchedule.vue';
import PurchaseReq from '@/components/PurchaseReq.vue';
import MachReq from '@/components/MachReq.vue';
import FGReq from '@/components/FGReq.vue';
import LoginPage from '@/components/LoginPage.vue';
import BOM from '@/components/BOM.vue';
import AssemblyPlan from '@/components/AssemblyPlan.vue';


const routes = [
  { path: '/login', component: LoginPage },
  { path: '/finished-goods-analysis', component: FinishedGoodsAnalysis },
  { path: '/component-analysis', component: ComponentAnalysis },
  { path: '/', redirect: '/finished-goods-analysis' },
  { path: '/oa-registrar', name: 'OARegistrar', component: OARegistrar },
  { path: '/delivery-schedule', name: 'DeliverySchedule', component: DeliverySchedule},
  { path: '/purchase-req', name: 'PurchaseReq', component: PurchaseReq},
  { path: '/mach-req', name: 'MachReq', component: MachReq },
  { path: '/fg-req', name: 'FGReq', component: FGReq },
  { path: '/bom', name: 'BOM', component: BOM },
  { path: '/assembly-plan', name: 'AssemblyPlan', component: AssemblyPlan }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard to protect routes
router.beforeEach((to, from, next) => {
  const auth = localStorage.getItem('mra_auth');
  let loggedIn = false;
  if (auth) {
    try {
      const { expiry } = JSON.parse(auth);
      loggedIn = Date.now() < expiry;
    } catch {
      loggedIn = false;
    }
  }
  if (to.path === '/login') {
    // If already logged in, redirect to main page
    if (loggedIn) return next('/finished-goods-analysis');
    return next();
  }
  if (!loggedIn) {
    return next('/login');
  }
  next();
});

export default router